import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { automationDataSchema, documentRequestAutomationsSchema, documentRequestAutomationsDefinitionSchema } from "./automation-schema";
import { normalize } from "normalizr";
import * as automationAPI from "../api/automation-api";
import { CLEAR_CURRENT_AUTOMATION, SET_AUTOMATION_DATA, SET_APPLICATION_AUTOMATIONS, SET_EMAILS_SYNCED, SET_EMAIL_SIGNATURE, SET_LOADING, SET_SAVING_STATUS, SET_SAVING, SET_EDITING, SET_TRIGGER_COLLAPSE, SET_DELETING, CLEAR_AUTOMATION_TO_DELETE, SET_AUTOMATION_SCHEDULED_EMAILS, SET_DEFAULT_LIST, SET_AUTOMATION_STATISTICS, SET_APPLICATION_AUTOMATION_STATUS, SET_APPLICATION_AUTOMATION_DATA, SET_DOCUMENT_REQUEST_AUTOMATIONS, SET_DOCUMENT_REQUEST_AUTOMATION_SCHEMA, SET_DOCUMENT_REQUEST_AUTOMATION_ACTIVE, SET_DOCUMENT_REQUEST_AUTOMATION_RULE, SET_AUTOMATION_DATA_LOADED } from "./automation-mutations";
import { createCampaign, updateCampaign, getCampaignScheduleEmails, deleteCampaignScheduleEmail, getList, getCampaignStatistics } from "../../../marketing/api/marketing-api";
import { getAutomation } from "../api/automation-api";
import { AUTOMATION_CLEAN } from "./automation-getters";
import Err from "../../../../routes/error";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
import { getSyncedEmails } from "@Broker/@Modules/settings/api/settings-api";
import { getEmailSignature } from "@Broker/@Modules/main/api/account-api";
import { cloneDeep, omit } from "lodash";
export const LOAD_AUTOMATION_DATA = "LOAD_AUTOMATION_DATA";
export const SAVE_AUTOMATION = "SAVE_AUTOMATION";
export const DELETE_AUTOMATION = "DELETE_AUTOMATION";
export const LOAD_APPLICATION_AUTOMATIONS = "LOAD_APPLICATION_AUTOMATIONS";
export const UPDATE_APPLICATION_AUTOMATION = "UPDATE_APPLICATION_AUTOMATION";
export const LOAD_AUTOMATION_RECIPIENTS = "LOAD_AUTOMATION_RECIPIENTS";
export const DELETE_SCHEDULED_EMAIL = "DELETE_SCHEDULED_EMAIL";
export const LOAD_DEFAULT_LIST = "LOAD_DEFAULT_LIST";
export const CREATE_APPLICATION_AUTOMATION = "CREATE_APPLICATION_AUTOMATION";
export const LOAD_AUTOMATION_STATISTICS = "LOAD_AUTOMATION_STATISTICS";
export const LOAD_PAGINATED_AUTOMATION_RECIPIENTS = "LOAD_PAGINATED_AUTOMATION_RECIPIENTS";
export const UPDATE_APPLICATION_AUTOMATION_STATUS = "UPDATE_APPLICATION_AUTOMATION_STATUS";
export const LOAD_DOCUMENT_REQUEST_AUTOMATIONS = "LOAD_DOCUMENT_REQUEST_AUTOMATIONS";
export const UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE = "UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE";
const actions = {
  [LOAD_AUTOMATION_DATA]: async context => {
    context.commit(CLEAR_CURRENT_AUTOMATION);
    if (!context.state.automationsDataLoaded) {
      context.commit(SET_LOADING, true);
    }
    const emailSyncRequest = getSyncedEmails();
    const emailSignatureRequest = getEmailSignature();
    const automationRequest = getAutomation();
    const [emailSyncData, automationData, emailSignatureData] = await _Promise.all([emailSyncRequest, automationRequest, emailSignatureRequest]);
    const normalizedData = normalize(automationData, automationDataSchema);
    context.commit(SET_AUTOMATION_DATA, normalizedData);
    context.commit(SET_EMAILS_SYNCED, emailSyncData.emails);
    context.commit(SET_EMAIL_SIGNATURE, emailSignatureData.emailSignature);
    context.commit(SET_LOADING, false);
    context.commit(SET_AUTOMATION_DATA_LOADED, true);
  },
  [LOAD_APPLICATION_AUTOMATIONS]: async context => {
    try {
      const appLvlAutomationData = await getAutomation("application");
      const normalizedData = normalize(appLvlAutomationData, automationDataSchema);
      context.commit(SET_APPLICATION_AUTOMATIONS, normalizedData);
    } catch (e) {
      Err.handle(e);
    }
  },
  [SAVE_AUTOMATION]: async (context, data = {}) => {
    const automation = context.getters[AUTOMATION_CLEAN](data);
    context.commit(SET_SAVING_STATUS, true);
    try {
      context.commit(SET_SAVING, true);
      if (automation.id) {
        await automationAPI.saveAutomation(automation);
        context.commit(CLEAR_CURRENT_AUTOMATION);
        context.commit(SET_EDITING, false);
        Amplitude.logEvent("Automation edited", {
          page: "automation",
          subpage: "automation",
          automationId: automation.id,
          automationTrigger: automation.trigger
        });
      } else {
        await automationAPI.saveAutomation(automation);
        Amplitude.logEvent("Automation created", {
          page: "automation",
          subpage: "automation",
          automationTrigger: automation.trigger
        });
      }
      context.commit(SET_TRIGGER_COLLAPSE, {
        key: automation.trigger,
        value: true
      });
      showToast("success", "automationSaved");
      context.commit(SET_SAVING_STATUS, true);
    } catch (error) {
      var _error$responseJSON;
      context.commit(SET_SAVING_STATUS, false);
      showToast("error", ((_error$responseJSON = error.responseJSON) == null ? void 0 : _error$responseJSON.message) || "automationNotSaved");
      Amplitude.logHandledError(error, {});
      throw error;
    } finally {
      await context.dispatch(LOAD_AUTOMATION_DATA);
      context.commit(SET_SAVING, false);
      context.commit(CLEAR_CURRENT_AUTOMATION);
    }
  },
  [UPDATE_APPLICATION_AUTOMATION]: async (context, {
    automation
  }) => {
    const {
      "action-arguments": actionArguments,
      id
    } = automation;
    const {
      campaignId
    } = actionArguments;
    try {
      const actionArgumentsRaw = omit(actionArguments, "recipients");
      await updateCampaign(campaignId, _objectSpread(_objectSpread({}, actionArgumentsRaw), {}, {
        status: null
      }));
      context.commit(SET_APPLICATION_AUTOMATION_DATA, {
        id,
        actionArguments: actionArgumentsRaw
      });
      showToast("success", "automationSaved");
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_APPLICATION_AUTOMATION_STATUS]: async (context, {
    automation
  }) => {
    const {
      "action-arguments": actionArguments,
      id
    } = automation;
    const {
      campaignId,
      status
    } = actionArguments;
    try {
      const actionArgumentsRaw = omit(actionArguments, "recipients");
      context.commit(SET_APPLICATION_AUTOMATION_STATUS, {
        status,
        id
      });
      await updateCampaign(campaignId, actionArgumentsRaw);
      showToast("success", "automationSaved");
    } catch (e) {
      const inverseStatusParser = {
        active: "inactive",
        inactive: "active"
      };
      context.commit(SET_APPLICATION_AUTOMATION_STATUS, {
        status: inverseStatusParser[status],
        id
      });
      Err.handle(e);
    }
  },
  [CREATE_APPLICATION_AUTOMATION]: async (context, {
    automation
  }) => {
    try {
      const {
        "action-arguments": actionArguments,
        "trigger-arguments": triggerArguments,
        id
      } = automation;
      const {
        name,
        time
      } = triggerArguments;
      const automationName = `${time.value} ${time.type} ${name}`;
      const {
        templateId,
        subject,
        previewText
      } = actionArguments;
      const {
        defaultListId: listId,
        defaultEmailId: emailId,
        defaultEmailName: fromName
      } = context.rootState.AccountStore.accountPreferences;
      const details = {
        name: automationName,
        listId,
        templateId,
        emailId,
        segmentId: null,
        fromName,
        subject,
        previewText,
        type: "automated",
        automationCriteria: triggerArguments
      };
      const {
        campaignId
      } = await createCampaign(details);
      context.commit(SET_APPLICATION_AUTOMATION_DATA, {
        id,
        details: _objectSpread(_objectSpread({}, details), {}, {
          campaignId,
          status: "active"
        })
      });
      showToast("success", "automationCreated");
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_AUTOMATION]: async context => {
    context.commit(SET_SAVING, true);
    try {
      const automationToDeleteId = context.state.automationToDelete.id;
      await automationAPI.deleteAutomation(automationToDeleteId);
      showToast("success", "automationDeleted");
      Amplitude.logEvent("Automation deleted", {
        page: "automation",
        subpage: "automation",
        automationId: automationToDeleteId
      });
      context.commit(SET_SAVING_STATUS, true);
    } catch (error) {
      context.commit(SET_SAVING_STATUS, false);
      Err.handle(error, {}, "automationNotDeleted");
    } finally {
      context.commit(SET_SAVING, false);
      context.commit(SET_DELETING, false);
      context.commit(CLEAR_AUTOMATION_TO_DELETE);
      await context.dispatch(LOAD_AUTOMATION_DATA);
    }
  },
  [LOAD_AUTOMATION_RECIPIENTS]: async (context, {
    automation
  }) => {
    try {
      const {
        "action-arguments": actionArguments,
        id
      } = automation;
      const {
        campaignId
      } = actionArguments;
      const {
        scheduledEmails
      } = await getCampaignScheduleEmails(campaignId);
      context.commit(SET_AUTOMATION_SCHEDULED_EMAILS, {
        id,
        recipients: scheduledEmails
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_PAGINATED_AUTOMATION_RECIPIENTS]: async (context, {
    campaignId,
    paginationData
  }) => {
    try {
      const {
        scheduledEmails
      } = await getCampaignScheduleEmails(campaignId, paginationData);
      return scheduledEmails;
    } catch (e) {
      Err.handle(e);
      return [];
    }
  },
  [LOAD_AUTOMATION_STATISTICS]: async (context, {
    automation
  }) => {
    try {
      const {
        "action-arguments": actionArguments,
        id
      } = automation;
      const {
        campaignId
      } = actionArguments;
      const {
        statistics
      } = await getCampaignStatistics(campaignId);
      context.commit(SET_AUTOMATION_STATISTICS, {
        id,
        statistics
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_SCHEDULED_EMAIL]: async (context, {
    campaignId,
    scheduledEmailId
  }) => {
    try {
      await deleteCampaignScheduleEmail(campaignId, scheduledEmailId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_DEFAULT_LIST]: async context => {
    try {
      const {
        defaultListId
      } = context.rootState.AccountStore.accountPreferences;
      const defaultList = await getList(defaultListId);
      context.commit(SET_DEFAULT_LIST, defaultList);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_DOCUMENT_REQUEST_AUTOMATIONS]: async context => {
    try {
      const {
        documentRequestRules,
        schema
      } = await automationAPI.getDocumentRequestRules();
      const normalizedDocumentRequestRules = normalize(documentRequestRules, [documentRequestAutomationsSchema]);
      context.commit(SET_DOCUMENT_REQUEST_AUTOMATIONS, {
        byId: normalizedDocumentRequestRules.entities.documentRequestAutomations || {},
        allIds: normalizedDocumentRequestRules.result
      });
      const normalizedSchema = normalize(schema.rules, [documentRequestAutomationsDefinitionSchema]);
      context.commit(SET_DOCUMENT_REQUEST_AUTOMATION_SCHEMA, {
        byId: normalizedSchema.entities || {},
        allIds: normalizedSchema.result
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE]: async (context, {
    documentRequestRuleId,
    documentRequestRule,
    active
  }) => {
    const currentDocumentRequestAutomation = cloneDeep(context.state.documentRequestAutomations.byId[documentRequestRuleId]);
    try {
      if (!documentRequestRule) {
        documentRequestRule = currentDocumentRequestAutomation.documentRequestRule;
        context.commit(SET_DOCUMENT_REQUEST_AUTOMATION_ACTIVE, {
          documentRequestRuleId,
          active
        });
      } else {
        context.commit(SET_DOCUMENT_REQUEST_AUTOMATION_RULE, {
          documentRequestRuleId,
          documentRequestRule
        });
      }
      await automationAPI.updatedDocumentRequestRule(documentRequestRuleId, {
        documentRequestRule,
        active: active != null ? active : currentDocumentRequestAutomation.active,
        title: currentDocumentRequestAutomation.title,
        description: currentDocumentRequestAutomation.description
      });
    } catch (e) {
      Err.handle(e);
      context.commit(SET_DOCUMENT_REQUEST_AUTOMATION_RULE, {
        documentRequestRuleId,
        documentRequestRule: currentDocumentRequestAutomation.documentRequestRule
      });
    }
  }
};
export default actions;